import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("akdp-token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgUrl = (p) => (p ? `${BACKEND_URL}${p}` : "");

export const LOGO_WHITE = `${BACKEND_URL}/api/uploads/brand/logo-white.png`;
export const LOGO_WIDE = `${BACKEND_URL}/api/uploads/brand/logo-wide.png`;

export const money = (v) =>
  v == null ? null : `$${Number(v).toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
